package com.milta.feature.profile.domain.usecase

import com.milta.feature.profile.domain.repository.ProfileRepository

private const val MAX_LANGUAGE_LENGTH = 10

class UpdateLanguageUseCase(private val repository: ProfileRepository) {
    suspend operator fun invoke(language: String): Result<Unit> {
        require(language.isNotBlank()) { "language_required" }
        require(language.length <= MAX_LANGUAGE_LENGTH) { "language_too_long" }
        return repository.updateLanguage(language)
    }
}
